<template>
  <v-snackbar
    v-model="isOpen"
    :timeout="-1"
    top
    right
    class="notification-layout"
    @mouseover="handleNotificationHover"
    @mouseleave="handleNotificationLeave"
    @focusin="handleNotificationHover"
    @focusout="handleNotificationLeave"
  >
    <div v-if="targetState.length">
      <v-btn
        text
        fab
        class="notification-close-btn"
        x-small
        @click="closeNotification"
      >
        <v-icon small>
          mdi-close-circle
        </v-icon>
      </v-btn>
      <v-flex>
        <v-row no-gutters class="align-center">
          <v-col>
            <img
              v-if="targetState !== 'active' && targetState !== 'reboot'"
              class="state mr-5"
              :src="require(`@/assets/icons/status/${targetState}.svg`)"
              :title="$t(`device.update.states.${targetState}`)"
              alt="device-state"
            >
            <img
              v-else
              class="state mr-5"
              :src="require(`@/assets/icons/status/pending_active.svg`)"
              :title="$t(`device.update.states.${targetState}`)"
              alt="device-state-pending_active"
            >
          </v-col>
          <v-col cols="auto">
            <div v-if="targetState" class="notification--header">{{ title }}</div>
            <div class="notification--link-text">
              <ul>
                <li v-for="(result, index) in results" :key="`result-${index}`">
                  {{ result.quantity }} {{ result.message }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-flex>
    </div>
  </v-snackbar>
</template>
<script lang="ts">
import _ from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class DeviceStatusNotification extends Vue {
  @Prop({
    type: Boolean
  })
  private isNotificationDeviceStatusOpen!: boolean;

  @Prop({
    type: String
  })
  private targetState!: string;

  @Prop({
    type: Array
  })
  private requestResults!: Array<{code: number, message: string}>;

  private get title() {
    return `${this.$t('device.update.notification.title')} ${this.$t(`device.update.states.${this.targetState}`)}`;
  }

  private get results() {
    const uniques = _.uniqBy(this.requestResults, 'message').filter(u => u);
    const counted = _.map(uniques, (unique) => {
      const qty = this.requestResults.filter(rr => rr.message === unique.message).length;
      const i18n = `device.update.notification.${unique.message}`;
      const newUnique = {
        quantity: qty,
        message: this.$tc(i18n, qty)
      };
      return newUnique;
    });
    return counted;
  }

  private isOpen = false;

  private notificationTimeoutDuration = 8000;

  private notificationTimeout = setTimeout(() => {
    this.isOpen = false;
  }, this.notificationTimeoutDuration);

  private handleNotificationHover() {
    clearTimeout(this.notificationTimeout);
  }

  private handleNotificationLeave() {
    this.notificationTimeout = setTimeout(() => {
      this.isOpen = false;
    }, this.notificationTimeoutDuration);
  }

  private closeNotification() {
    clearTimeout(this.notificationTimeout);
    this.isOpen = false;
  }

  @Watch('isNotificationDeviceStatusOpen')
  private onNotificationStateChange() {
    clearTimeout(this.notificationTimeout);
    this.isOpen = this.isNotificationDeviceStatusOpen;
    this.notificationTimeout = setTimeout(() => {
      this.isOpen = false;
    }, this.notificationTimeoutDuration);
  }

  @Watch('isOpen')
  private onNotificationInternalStateChange() {
    if (!this.isOpen) {
      this.$emit('notificationClosed');
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./style/device-status-notification.scss";
</style>
